import { call, put, takeLatest } from "@redux-saga/core/effects";

import { ApiService } from "pwapi";

import {
  LABORDERS_LIST_FAILURE,
  LABORDERS_LIST_REQUEST,
  LABORDERS_LIST_SUCCESS,
} from "../actions/constants";

function* fetchLabOrders(action: any): any {
  try {
    const results = yield call(
      ApiService.listAdminLabOrders,
      action.payload.filters
    );
    yield put({
      type: LABORDERS_LIST_SUCCESS,
      payload: results,
    });
  } catch (e: any) {
    yield put({
      type: LABORDERS_LIST_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* labOrdersSaga() {
  yield takeLatest(LABORDERS_LIST_REQUEST, fetchLabOrders);
}
